<ng-container *ngIf="!!get && !!form" [formGroup]="form">
    <tt-select *ngIf="get.setting_show_oh_head_contact_pers_no !== '0'" ttLabel="contact_person" formControlName="contact_pers_no" [ttData]="customerPersons" ttDataId="item_id" ttDataName="item_name">
        <ng-container buttons>
            <tt-form-field-button
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_customerpersons"
                [ttTranslateTooltip]="true"
                ttGoto="customerpersons"
                [ttGotoParms]="{ cust_no: '' + form.controls.stat_cust_no.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-input *ngIf="get.setting_show_oh_head_customers_orderno !== '0'" ttLabel="customers_orderno" formControlName="customers_orderno"></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_project_name !== '0'" ttLabel="project_name" formControlName="project_name">
        <ng-container buttons>
            <tt-form-field-button
                *ngIf="+form.controls.project_keyno.value === 0"
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_selectproject"
                [ttTranslateTooltip]="true"
                ttGoto="selectproject"
                [ttGotoParms]="{ argtype: 'cust_no', argvalue: '' + form.controls.stat_cust_no.value }"
            ></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_customers_ref1 !== '0'" ttLabel="customers_ref1" formControlName="customers_ref1"></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_customers_ref2 !== '0'" ttLabel="customers_ref2" formControlName="customers_ref2"></tt-input>
    <tt-textarea *ngIf="get.setting_show_oh_head_message_from_sales !== '0'" ttLabel="message_from_sales" formControlName="message_from_sales"></tt-textarea>
    <tt-textarea *ngIf="get.setting_show_oh_head_message_to_supplier !== '0'" ttLabel="message_to_supplier" formControlName="message_to_supplier"></tt-textarea>
    <tt-input *ngIf="get.setting_show_oh_head_label !== '0'" ttLabel="orderhead_label" formControlName="label"></tt-input>
</ng-container>
